<div class="toc-layout-main"> 
  <ul class="dfwp-list"> 
     <li class="level-section level-item-pos level-item level-bullet"> 
        <div class="level-header"> 
           <span class="headertitle headermarker">
             <a href="/BidSupplierSubscription">{{'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Title' | translate}}</a><br></span></div> 
     </li> 
     <li class="level-section level-item-pos level-item level-bullet"> 
        <div class="level-header"> 
           <span class="headertitle headermarker"><a href="/BidSupplierSubscriptionReport">{{'ADMIN_USER.E_TENDER_FORM.BID_SUPPLIERS_SUBSCRIPTIONS_LISTING' | translate}}</a><br></span></div> 
     </li> 
      <li class="level-section level-item-pos level-item level-bullet" *ngIf="creator==true"> 
        <div class="level-header"> 
           <span class="headertitle headermarker"><a href="/CreateTender">{{'ADMIN_USER.E_TENDER_FORM.TENDER_CREATION' | translate}}</a><br></span></div> 
     </li> 
      <li class="level-section level-item-pos level-item level-bullet"> 
        <div class="level-header"> 
           <span class="headertitle headermarker"><a href="/TenderList">{{'FRONT_USER.SERVICES.TENDERS' | translate}}</a><br></span></div> 
     </li> 
     <li class="level-section level-item-pos level-item level-bullet"> 
      <div class="level-header"> 
         <span class="headertitle headermarker"><a href="/etenderSupplierEvaluationList">{{'FRONT_USER.SERVICES.TENDERSEVALUATIONLIST' | translate}}</a><br></span></div> 
   </li> 
  </ul> 
</div>